export type HttpRequest = {
  url: string;
  method: HttpMethod;
  body?: any;
  params?: Record<string, any>;
  headers?: any;
  responseType?:
    | 'arraybuffer'
    | 'text'
    | 'blob'
    | 'document'
    | 'stream'
    | 'json';
};

export interface HttpClient<R = any> {
  request: (data: HttpRequest) => Promise<HttpResponse<R>>;
}

export type HttpMethod = 'post' | 'get' | 'put' | 'delete' | 'patch';

export enum HttpStatusCode {
  ok = 200,
  created = 201,
  noContent = 204,
  badRequest = 400,
  unauthorized = 401,
  forbidden = 403,
  notFound = 404,
  conflict = 409,
  tooManyRequests = 429,
  serverError = 500,
}

export type HttpResponse<T = any> = {
  statusCode: HttpStatusCode;
  body?: T & { message?: string };
};
